import { format } from 'date-fns'

export const Handle = ({ handle: { id, value, percent }, getHandleProps }) => {
  //console.log('h -> ' + value);
  return (
    <div
      style={{
        left: `${percent}%`,
        position: 'absolute',
        marginLeft: '0%',
        marginTop: 10,
        zIndex: 2,
        width: 6,
        height: 12,
        border: 0,
        textAlign: 'center',
        cursor: 'pointer',
        borderRadius: '20%',
        backgroundColor: '#f3d0d0',
        color: '#333',
      }}
      {...getHandleProps(id)}
    />
  )
}

export const Track = ({ source, target, getTrackProps, index }) => {
  return (
    <div
      style={{
        position: 'absolute',
        height: 4,
        zIndex: 1,
        marginTop: 15,
        backgroundColor: '#f3d0d0',
        borderRadius: 5,
        cursor: 'pointer',
        left: `${source.percent}%`,
        width: `${target.percent - source.percent}%`,
      }}
      {
        ...getTrackProps() /* this will set up events if you want it to be clickeable (optional) */
      }
    ></div>
  )
}

export const Tick = ({ tick, count }) => {
  return (
    <div>
      <div
        style={{
          position: 'absolute',
          marginTop: 10,
          marginLeft: -0.5,
          width: 1,
          height: 8,
          backgroundColor: 'silver',
          left: `${tick.percent}%`,
        }}
      />
      <div
        style={{
          position: 'absolute',
          marginTop: 20,
          fontSize: 10,
          textAlign: 'center',
          marginLeft: `${-(100 / count) / 2}%`,
          width: `${100 / count}%`,
          left: `${tick.percent}%`,
          color: 'black',
        }}
      >
        {format(tick.value, 'HH:mm')}
      </div>
    </div>
  )
}
